<template>
  <v-dialog v-model="visible" max-width="100%">
    <v-card style="overflow-y: hidden">
      <v-card-title class="py-2 px-4">{{ titulo }}</v-card-title>

      <v-divider class="my-0"></v-divider>

      <v-card-text class="pa-4">
        <v-row>
          <v-col v-for="(item, indice) in listado" :key="indice" cols="12" lg="4" class="pa-0">
            <ListadoItem :nombreCampo="item.nombre" :valorCampo="item.valor" />
          </v-col>

          <v-col cols="12">
            <ListadoDetallesPagosUniversidades
              ref="listadoRef"
              :items="form.detallesPagosUniversidades"
              :cargando="false" />
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider class="my-0"></v-divider>

      <v-card-actions>
        <v-btn color="blue darken-1" text @click.prevent="cerrar"> Cerrar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import 'vue-select/dist/vue-select.css';
import modalFormMixin from '../mixins/modal-form.mixin';
import { concatenar, formatearValorAMoneda } from '../utils/funciones';
import ListadoDetallesPagosUniversidades from './ListadoDetallesPagosUniversidades.vue';
import ListadoItem from './ListadoItem.vue';

export default {
  name: 'ModalMostrarPagoUniversidad',
  mixins: [modalFormMixin],
  components: {
    ListadoItem,
    ListadoDetallesPagosUniversidades,
  },
  props: {
    monto: {
      type: [Number, String],
      required: true,
    },
  },
  computed: {
    numeroEstudiantes() {
      return this.form.detallesPagosUniversidades.length;
    },
    montoTotal() {
      return (this.monto * this.numeroEstudiantes).toFixed(2);
    },
    listado() {
      return [
        { nombre: 'Número de comprobante', valor: this.form.numeroComprobante },
        { nombre: 'Fecha de depósito', valor: this.form.fechaDeposito },
        { nombre: 'Nombre del depositante', valor: this.form.nombreDepositante },
        { nombre: 'Monto por estudiante', valor: formatearValorAMoneda(this.monto) },
        { nombre: 'Número de estudiantes', valor: this.numeroEstudiantes },
        { nombre: 'Monto total', valor: formatearValorAMoneda(this.montoTotal) },
      ];
    },
  },
  methods: {
    generarObjetoFormRegistrar() {
      return {
        id: null,
        solicitudPagoId: this.solicitudPagoId,
        numeroComprobante: null,
        fechaDeposito: null,
        nombreDepositante: concatenar(
          this.$store.state.DATA_USER.nombres,
          this.$store.state.DATA_USER.pri_apellido,
          this.$store.state.DATA_USER.seg_apellido,
        ),
        detallesPagosUniversidades: [],
      };
    },
    generarObjetoFormEditar(data) {
      return {
        id: data.id,
        solicitudPagoId: data.solicitudPagoId,
        numeroComprobante: data.numeroComprobante,
        fechaDeposito: data.fechaDeposito,
        nombreDepositante: data.nombreDepositante,
        detallesPagosUniversidades: data.detallesPagosUniversidades,
      };
    },
    abrir(accion, data = []) {
      this.abrirMixin(accion, data);
    },
  },
};
</script>

<style scoped>
::v-deep .v-select.v-text-field--outlined:not(.v-text-field--single-line).v-input--dense .v-select__selections {
  padding: 0px 0;
}

::v-deep .v-text-field .v-input__control .v-input__slot {
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
}

::v-deep .v-text-field--outlined.v-input--dense .v-label {
  top: 5px;
}

::v-deep .v-text-field .v-label {
  font-weight: 400;
}
</style>